import React from 'react';
import { Link } from 'react-router-dom';
import { img } from '../../utils/images';
import { useLocale } from '../../i18n/LocaleContext';
import './CoverTrio.css';

// La une : les trois vedettes en entier, serrées comme sur une photo de
// classe sous le titre du magazine. Chacune mène à sa pièce ; la pastille du prix
// est collée sur une pièce, pas sur un objet qu'on ne vend pas.
export default function CoverTrio({ stars, labels, priceFrom, stickerLabel }) {
  const { lp } = useLocale();
  return (
    <div className="cover-trio">
      {stars.map(({ id, slug, width, height }) => (
        <Link key={id} to={lp(`/produit/${slug}`)} className={`cover-star cover-star-${id} cover-trio-${id}`}
          style={{ aspectRatio: `${width} / ${height}` }} aria-label={labels[id]} data-testid={`cover-star-${id}`}>
          <span className="cover-star-shape">
            <img src={img(slug)} alt="" width={width} height={height} fetchPriority={id === 'sylvette' ? 'high' : undefined} draggable="false" />
          </span>
        </Link>
      ))}
      {priceFrom && (
        <p className="cover-trio-sticker" data-testid="cover-sticker">
          <b>{priceFrom}</b>
          <span>{stickerLabel}</span>
        </p>
      )}
    </div>
  );
}
